 document.addEventListener('DOMContentLoaded', function () {
    const path = window.location.pathname;
    const shouldRun = path === '/' || path === '/cart';
    if (!shouldRun) {
      console.log("Not on homepage/cart. Skipping.");
      return;
    }

    const selectedCountry = $.cookie('selectedCountryCode');
    const geoLocated = $.cookie('geo_located_country') || $.cookie('localization');
    const currentLocalization = $.cookie('localization');
    const lastSubmittedCountry = $.cookie('lastSubmittedCountry'); // NEW

    const countryForm = $('#HeaderCountryForm');
    const countryInput = countryForm.find("input[name='country_code']");
    const currentInputValue = countryInput.val();

    console.log("State:", {
      selectedCountry,
      geoLocated,
      currentLocalization,
      currentInputValue,
      lastSubmittedCountry,
    });

    // Manual selection listener
    $('.disclosure__item a').on('click', function () {
      const selected = $(this).data('value');
      if (selected) {
        console.log("Country manually selected:", selected);
        document.cookie = 'selectedCountryCode=' + selected + '; path=/';
      }
    });

    // Set geo_located_country cookie (once)
    if (!$.cookie('geo_located_country')) {
      $.cookie('geo_located_country', currentLocalization, { expires: 7 });
      console.log("Set geo_located_country to:", currentLocalization);
    }

    const targetCountry = selectedCountry || geoLocated;

    if (!targetCountry) {
      console.log("No target country found. Exiting.");
      return;
    }

    if (targetCountry === currentInputValue) {
      console.log("Input already has target country.");
      return;
    }

    if (lastSubmittedCountry === targetCountry) {
      console.log("Already submitted this country before. Skipping.");
      return;
    }

    // Submit form once
    console.log("Submitting form with country:", targetCountry);
    countryInput.val(targetCountry);
    $.cookie('lastSubmittedCountry', targetCountry, { path: '/', expires: 1 });
    countryForm.submit();
  });

// document.addEventListener('DOMContentLoaded', function () {
//     const path = window.location.pathname;
//     const onHome = path === '/';
//     const onCart = path === '/cart';
//     const onArabicOM = path.startsWith('/ar-om');
//     const onArabicKSA = path.startsWith('/ar-ksa');

//     const selectedCountry = $.cookie('selectedCountryCode');
//     const geoLocated = $.cookie('geo_located_country') || $.cookie('localization');
//     const currentLocalization = $.cookie('localization');
//     const lastSubmittedCountry = $.cookie('lastSubmittedCountry');

//     const countryForm = $('#HeaderCountryForm');
//     const countryInput = countryForm.find("input[name='country_code']");
//     const currentInputValue = countryInput.val();

//     // console.log("State:", {
//     //   selectedCountry,
//     //   geoLocated,
//     //   currentLocalization,
//     //   currentInputValue,
//     //   lastSubmittedCountry,
//     //   path
//     // });

//     // Handle manual country selection
//     $('.disclosure__item a').on('click', function (e) {
//       const selected = $(this).data('value');
//       if (selected) {
//         // console.log("Manually selected:", selected);
//         document.cookie = 'selectedCountryCode=' + selected + '; path=/';

//         if ((selected === 'OM' && !onArabicOM) || ((selected === 'SA' || selected === 'KSA') && !onArabicKSA)) {
//           const redirectPath = selected === 'OM' ? '/ar-om' : '/ar-ksa';
//           // console.log("Redirecting to", redirectPath);
//           e.preventDefault();
//           window.location.href = redirectPath;
//           return;
//         }

//         if ((onArabicOM || onArabicKSA) && selected !== 'OM' && selected !== 'SA' && selected !== 'KSA') {
//           // console.log("Redirecting to English version from Arabic page");
//           e.preventDefault();
//           window.location.href = '/en-' + selected.toLowerCase();
//           return;
//         }

//         $.cookie('lastSubmittedCountry', selected, { path: '/', expires: 1 });
//         countryInput.val(selected);
//         countryForm.submit();
//       }
//     });

//     // Set geo-located cookie once
//     if (!$.cookie('geo_located_country')) {
//       $.cookie('geo_located_country', currentLocalization, { expires: 7 });
//       // console.log("Set geo_located_country:", currentLocalization);
//     }

//     const targetCountry = selectedCountry || geoLocated;

//     if (!targetCountry) {
//       // console.log("No target country found. Exiting.");
//       return;
//     }

//     if (targetCountry === currentInputValue && lastSubmittedCountry === targetCountry) {
//       // console.log("Current country already correct. No action needed.");
//       return;
//     }

//     // Prevent redirect override if user manually navigated to /ar-om or /ar-ksa
//     if ((onArabicOM && targetCountry !== 'OM') || (onArabicKSA && targetCountry !== 'SA' && targetCountry !== 'KSA')) {
//       // console.log("Preventing redirect from manually typed Arabic URL");
//       return;
//     }

//     if ((targetCountry === 'OM' && !onArabicOM) || ((targetCountry === 'SA' || targetCountry === 'KSA') && !onArabicKSA)) {
//       const redirectPath = targetCountry === 'OM' ? '/ar-om' : '/ar-ksa';
//       // console.log("Auto-redirect to", redirectPath);
//       $.cookie('lastSubmittedCountry', targetCountry, { path: '/', expires: 1 });
//       window.location.href = redirectPath;
//       return;
//     }

//     if (targetCountry !== currentInputValue) {
//       // console.log("Submitting form with:", targetCountry);
//       countryInput.val(targetCountry);
//       $.cookie('lastSubmittedCountry', targetCountry, { path: '/', expires: 1 });
//       countryForm.submit();
//     } else {
//       // console.log("Current country already correct. No action needed.");
//     }
//   });